import React from 'react'
import { motion } from "framer-motion";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Col, Row, Container, Card, Button } from 'react-bootstrap';
import { HiExternalLink } from "react-icons/hi";

import {projects} from '../../data'

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 5,
        partialVisibilityGutter: 40
    },
    largeDesktop: {
        breakpoint: { max: 3000, min: 1500 },
        items: 4,
        partialVisibilityGutter: 40
    },
    desktop: {
        breakpoint: { max: 1500, min: 1024 },
        items: 3,
        partialVisibilityGutter: 40
    },
    tablet: {
        breakpoint: { max: 1024, min: 500 },
        items: 2,
        partialVisibilityGutter: 30
    },
    mobile: {
        breakpoint: { max: 500, min: 0 },
        items: 1,
        partialVisibilityGutter: 20
    }
};
const containerVariants = {
    initial: {
        opacity: 0,
        x: '-100vw'
    },
    animate: {
        opacity: 1,
        x: 0,
        transition: {
            type: 'spring'
        }
    },
    exit: {
        x: '50vw',
        opacity: 0,
        transition: {
            duration: 0.5
        }
    }
}
const cardVariants = {
    hover: {
        scale: 1.1,
        boxShadow: '2px 2px 20px 0px #989898'
    }
}

const Portfolio = () => {
    const webProjectBox = projects.webProjects.map(webProject => {
        return (
        <motion.div className="project-box"
            variants={cardVariants}
            whileHover="hover"
        >
            <Card style={{ width: '18rem' }}>
                <Card.Img variant="top" src={webProject.image} />
                <Card.Body>
                    <Card.Title>{webProject.name}</Card.Title>
                        <Button href={webProject.link} target='__blank__' variant="outline-info">Visit <HiExternalLink /></Button>
                </Card.Body>
            </Card>
        </motion.div>
    )})
    const uiuxProjectBox = projects.uiuxProjects.map(uiuxProject => (
        <motion.div className="project-box"
            variants={cardVariants}
            whileHover="hover"
        >
            <Card style={{ width: '18rem' }}>
                <Card.Img variant="top" src={uiuxProject.image} />
                <Card.Body>
                    <Card.Title>{uiuxProject.name}</Card.Title>
                    <Button href={uiuxProject.link} target='__blank__' variant="outline-info">Visit <HiExternalLink /></Button>
                </Card.Body>
            </Card>
        </motion.div>
    ))
    const appProjectBox = projects.appProjects.map(appProject => (
        <motion.div className="project-box"
            variants={cardVariants}
            whileHover="hover"
        >
            <Card style={{ width: '18rem' }}>
                <Card.Img variant="top" src={appProject.image} />
                <Card.Body>
                    <Card.Title>{appProject.name}</Card.Title>
                    <Button href={appProject.link} target='__blank__' variant="outline-info">Visit <HiExternalLink /></Button>
                </Card.Body>
            </Card>
        </motion.div>
    ))
    return (
        <motion.section id="portfolio"
            variants={containerVariants}
            initial="initial"
            animate="animate"
            exit="exit"
        >
            <Container>
                <div>
                    <h2 className="text-left font-poppins font-weight-bold">
                        Web Development Projects
                    </h2>
                    <Carousel
                        responsive={responsive}
                        showDots={false}
                        infinite={true}
                        autoPlay={true}
                        autoPlaySpeed={1000}
                        arrows={false}
                    >
                        {webProjectBox}
                    </Carousel>
                </div>
                <div>
                    <h2 className="text-left font-poppins font-weight-bold">
                        UI/UX Projects
                    </h2>
                    <Carousel
                        responsive={responsive}
                        showDots={false}
                        infinite={true}
                        autoPlay={true}
                        autoPlaySpeed={1000}
                        arrows={false}
                    >
                        {uiuxProjectBox}
                    </Carousel>
                </div>
                <div>
                    <h2 className="text-left font-poppins font-weight-bold">
                        App Projects
                    </h2>
                    <Carousel
                        responsive={responsive}
                        showDots={false}
                        infinite={true}
                        autoPlay={true}
                        autoPlaySpeed={1000}
                        arrows={false}
                    >
                        {appProjectBox}
                    </Carousel>
                </div>
            </Container>

        </motion.section>
    )
}

export default Portfolio